import { render, staticRenderFns } from "./Gmzsyqktj.vue?vue&type=template&id=e96ff8c8&scoped=true&"
import script from "./Gmzsyqktj.vue?vue&type=script&lang=js&"
export * from "./Gmzsyqktj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96ff8c8",
  null
  
)

export default component.exports